<script>
  import CRUD from './CRUD.svelte';
  import { fetchAtributos, saveAtributo, removeAtributo, searchAtributos, subscribeToAtributos, unsubscribeFromAtributos } from '../controllers/atributoController.js';

  // Opciones para 'tipo' y 'tipo_dato'
  let tipos = [
    { key: 'producto', value: 'Productos' },
    { key: 'cliente', value: 'Clientes' },
    { key: 'proveedor', value: 'Proveedores' },
    { key: 'vendedor', value: 'Vendedores' },
    { key: 'bodega', value: 'Bodegas' },
    { key: 'documento', value: 'Documentos' }
  ];

  let tipoDatos = [
    { key: 'caracter', value: 'Carácter' },
    { key: 'numerico', value: 'Numérico' },
    { key: 'fecha', value: 'Fecha' },
    { key: 'booleano', value: 'Booleano' },
    { key: 'lista', value: 'Lista' }
  ];

  // Configuración de las columnas para la tabla CRUD
  let atributoColumns = [
    { label: 'Descripción', field: 'descrip', type: 'text' },
    { label: 'Entidad', field: 'tipo', type: 'text' },
    { label: 'Tipo de Dato', field: 'tipo_dato', type: 'text' },
    { label: 'Requerido', field: 'requerido', type: 'bool' },
    { label: 'Visible', field: 'visible', type: 'bool' },
    { label: 'Modificable', field: 'modificable', type: 'bool' },
    { label: 'Estado', field: 'sta', type: 'bool' },
  ];

  // Objeto para un nuevo atributo
  let newAtributo = {
    descrip: '',
    tipo: '',           // Inicialmente selecciona la primera opción
    tipo_dato: '',   // Inicialmente selecciona la primera opción
    requerido: false,
    visible: true,
    modificable: true,
    sta: true,
  };

  // Configuración de las columnas para el formulario de edición
  let editColumns = [
      { label: 'Descripción', key: 'descrip', type: 'text', required: true },
      { label: 'Entidad', key: 'tipo', type: 'select', options: tipos, required: true },
      { label: 'Tipo de Dato', key: 'tipo_dato', type: 'select', options: tipoDatos, required: true },
      { label: 'Requerido', key: 'requerido', type: 'checkbox' },
      { label: 'Visible', key: 'visible', type: 'checkbox' },
      { label: 'Modificable', key: 'modificable', type: 'checkbox' },
      { label: 'Estado', key: 'sta', type: 'checkbox' },
  ]; 

</script>

<!-- Componente CRUD para Atributos -->
<CRUD 
  title="Atributos"
  entityName="atributo"
  newEntity={newAtributo}
  columns={atributoColumns}
  fetchEntities={fetchAtributos}
  saveEntity={saveAtributo}
  removeEntity={removeAtributo}
  searchEntities={searchAtributos}
  subscribeToChanges={subscribeToAtributos}
  unsubscribeFromChanges={unsubscribeFromAtributos}
  editColumns={editColumns}
/>
